import Icon from '../components/Icon.vue'

Icon.register({"project-diagram":{"width":640,"height":512,"paths":[{"d":"M384 320H256C238.3 320 224 334.3 224 352V480C224 497.7 238.3 512 256 512H384C401.7 512 416 497.7 416 480V352C416 334.3 401.7 320 384 320zM192 32C192 14.3 177.7 0 160 0H32C14.3 0 0 14.3 0 32V160C0 177.7 14.3 192 32 192H127.7L200.9 320C212 301 232.4 288 256 288H256.3L192 175.5V128H416V64H192V32zM608 0H480C462.3 0 448 14.3 448 32V160C448 177.7 462.3 192 480 192H608C625.7 192 640 177.7 640 160V32C640 14.3 625.7 0 608 0z"}]}})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/project-diagram.js
// module id = g0jS
// module chunks = 0